import { Outlet, createFileRoute } from "@tanstack/react-router";

// Layout route only: obligations/ has children (index = the list, $taxType = the detail).
// Rendering the list page here would shadow every child — the pre-2026-07-28 bug that made
// the obligation detail page unreachable.
export const Route = createFileRoute("/(app)/dashboard/obligations")({
  component: () => <Outlet />,
});
